export class Debouncer {
  constructor(callable, timeoutMs, fastFirstCall = false) {
    this.callable = () => callable();
    this.timeoutMs = timeoutMs;
    this.fastFirstCall = fastFirstCall;
    this.timeout = undefined;
  }

  execute() {
    if (this.timeout) {
      this.clearTimeout();
    } else if (this.fastFirstCall) {
      this.executeNow();
    }

    this.timeout = setTimeout(() => this.executeNow(), this.timeoutMs);
  }

  executeNow() {
    this.callable();

    if (this.timeout) {
      this.clearTimeout();
    }
  }

  clearTimeout() {
    clearTimeout(this.timeout);
    this.timeout = undefined;
  }
}
